import { Column, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { ConfirmPopup, FieldValue, InputSelect, Label } from '~/commonComponents';
import { TextAreaField } from '~/components/shared/forms';
import { useRequestReport } from './hooks';
import { Controller } from 'react-hook-form';
import { useEffect } from 'react';

interface IProps {
  onClose: () => void;
}

export const RequestReportPopup = ({ onClose }: IProps) => {
  const {
    controller: {
      control,
      formState: { isValid },
    },
    isError,
    isLoading,
    isSuccess,
    onSubmit,
  } = useRequestReport();

  useEffect(() => {
    if (!isLoading && (isSuccess || isError)) {
      onClose();
    }
  }, [isError, isLoading, isSuccess, onClose]);

  return (
    <ConfirmPopup
      leftButtonAction={onClose}
      leftButtonDisabled={isLoading}
      leftButtonStyle={{ width: 180 }}
      leftButtonText="Close"
      rightButtonAction={onSubmit}
      rightButtonDisabled={!isValid}
      rightButtonLoading={isLoading}
      rightButtonStyle={{ width: 180 }}
      rightButtonText="Submit Request"
      title="Request Report"
      modalStyle={{ width: 560 }}
    >
      <Typography as="span" textAlign="center" color={colors.neutral[500]}>
        Please complete the form below to request a transactions
        <br />
        report from GoTu. Once submitted, an email will be sent to
        <br />
        the address specified below.
      </Typography>
      <Column gap={4} pb={6} style={{ marginTop: 24, width: 386 }}>
        <Controller
          control={control}
          name="email"
          rules={{ required: true, pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/ }}
          render={({ field }) => (
            <FieldValue
              customInputStyle={{ width: '100%', boxSizing: 'border-box' }}
              label="Forwarding Email"
              placeholder="Enter Forwarding Email"
              required
              shouldCapitalize={false}
              value={field.value}
              setValue={field.onChange}
            />
          )}
        />
        <Column>
          <Label text="Transaction Date Range" required />
          <Controller
            control={control}
            name="ranges"
            rules={{ required: true }}
            render={({ field }) => (
              <InputSelect
                isSelectVisible={false}
                options={[
                  { title: 'All', value: 'All' },
                  { title: 'Current Month', value: 'Current Month' },
                  { title: 'Last Month', value: 'Last Month' },
                  { title: 'Previous 3 months', value: 'Previous 3 months' },
                  { title: 'Previous 6 months', value: 'Previous 6 months' },
                  { title: 'Year to Date', value: 'Year to Date' },
                  { title: 'Last Year', value: 'Last Year' },
                ]}
                setValue={field.onChange}
                value={field.value}
              />
            )}
          />
        </Column>
        <Column>
          <Label text="Notes" marginBottom={8} required={false} />
          <Controller
            control={control}
            name="notes"
            render={({ field }) => (
              <TextAreaField {...field} height={70} />
            )}
          />
        </Column>
      </Column>
    </ConfirmPopup>
  );
};
